import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { InputTextarea } from 'primereact/inputtextarea';

import { updateSection } from '../../actions/car.action';
import { ContainerTemplate } from '../../components/core-components/templates/container.template';
import { updateContentCar } from '../../slices/car.slice';
import { useAppDispatch, useAppSelector } from '../../store/store';

export const CarsListContentPage = () => {
  const dispatch = useAppDispatch();

  const { content } = useAppSelector(({ car }) => car);
  const handleUpdateCarsListContent = (key: string, value: string) => {
    dispatch(updateContentCar({ ...content, [key]: value }));
  };

  const handleSaveBanner = () => {
    dispatch(updateSection({ section: content }));
  };

  return (
    <ContainerTemplate>
      <Card title="Контент страницы машин" className={'border-2 border-yellow'}>
        <div>
          <label htmlFor="headline">Заголовок</label>
          <InputTextarea
            className={'w-full'}
            id="headline"
            value={content.title ?? ''}
            onChange={({ target }) => handleUpdateCarsListContent('title', target.value)}
          />
        </div>
        <div className="mt-2">
          <label htmlFor="description">Описание</label>
          <InputTextarea
            className={'w-full'}
            id="description"
            value={content.description ?? ''}
            onChange={({ target }) => handleUpdateCarsListContent('description', target.value)}
          />
        </div>
        <Button
          label="Сохранить"
          icon="pi pi-check"
          className={'mt-2'}
          onClick={handleSaveBanner}
        />
      </Card>
    </ContainerTemplate>
  );
};
